<!-- Trigger to Open the Modal -->
<button type="button" class="btn bg-transparent btn-sm mb-4 px-2 py-0" data-bs-toggle="modal" data-bs-target="#categoryTagManagerModal">
  <img src="@/assets/images/tag (1).png" alt="" class="w-50">
</button>

<!-- Modal -->
<div class="modal fade" id="categoryTagManagerModal" tabindex="-1" aria-labelledby="category_tag_manager_label" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content rounded-5">

      <div class="modal-header">
        <h6 id="category_tag_manager_label">Category & Tag Manager</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <!-- Add New Category Section -->
        <div class="mb-4">
          <div class="d-flex gap-2">
            <input
              type="text"
              v-model="category_name"
              @keypress.enter="handleKeyPress('category')"
              class="rounded-5 shadow-sm form-control form-control-sm text-xxs"
              placeholder="Enter category name..."
            />
          </div>
        </div>

        <!-- Categories List -->
        <div v-if="categories.length === 0" class="text-center text-muted py-5">
          <i class="bi bi-folder-fill display-4 opacity-25 mb-2"></i>
          <p class="lead">No categories yet. Create your first category above!</p>
        </div>

        <div v-else class="vstack gap-5">
          <div
            v-for="category in categories"
            :key="category.id"
            class="card border border-secondary-subtle shadow-sm mb-2"
          >
            <div class="card-header d-flex justify-content-between align-items-center bg-light">
              <h5 class="mb-0 d-flex align-items-center gap-2 text-dark">
                <i class="bi bi-folder-fill text-primary"></i>
                {{ category.name }}
                <span class="badge bg-secondary ms-2">
                  {{ category.tags?.length || 0 }} tags
                </span>
              </h5>
              <button
                class="btn btn-sm btn-outline-danger"
                @click.prevent="delete_category(category.id)"
                aria-label="Delete Category"
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>

            <div class="card-body">
              <!-- Add Tag Input -->
              <div class="d-flex gap-2 mb-3">
                <input
                  type="text"
                  :value="tag_name.get(category.id) || ''"
                  @input="e => handleTagInputChange(category.id, e.target.value)"
                  @keypress.enter="handleKeyPress('tag', category.id)"
                  class="form-control rounded-5"
                  placeholder="Enter tag name..."
                />
                <button
                  class="btn btn-sm btn-secondary text-xs rounded-5"
                  :disabled="!(tag_name.get(category.id) || '').trim()"
                  @click="() => addTag(category.id)"
                >
                  <i class="bi bi-tag-fill"></i> Add Tag
                </button>
              </div>

              <!-- Tag List -->
              <div v-if="category.tags && category.tags.length === 0" class="text-center text-muted fst-italic py-3">
                No tags yet. Add your first tag above!
              </div>
              <div v-else class="d-flex flex-wrap gap-2">
                <span
                  v-for="tag in category.tags"
                  :key="tag.id"
                  class="badge bg-success-subtle text-success d-flex align-items-center gap-2 px-3 py-2 border border-success rounded-pill"
                >
                  <i class="bi bi-tag"></i>
                  {{ tag.name }}
                  <button
                    class="btn btn-sm btn-outline-danger btn-close btn-close-white p-0"
                    style="filter: invert(1);"
                    @click="deleteTag(category.id, tag.id)"
                  ></button>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Summary -->
        <div class="mt-5 bg-light p-3 rounded">
          <div class="d-flex justify-content-center gap-4 text-secondary small">
            <div><i class="bi bi-folder"></i> {{ categories.length }} Categories</div>
            <div><i class="bi bi-tag"></i> {{ totalTags }} Total Tags</div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          class="btn btn-sm btn-primary rounded-3 text-xs shadow-sm"
          :disabled="categories.length === 0"
          @click="create_tag_category"
        >
          <i class="bi bi-check-circle me-1"></i> Save Category & Tags
        </button>
      </div>

    </div>
  </div>
</div>
